import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { LEGALS_VERSION } from '@mote/helpers/constants'
import { useGoalsState } from '@mote/helpers/hooks/business'
import { Block, Spinner } from '@mote/ui'
import { useAuth } from '../../auth/useAuth'
import { OnboardingLayout } from '../../layouts'
import { OnboardingInvitation } from './OnboardingInvitation'
import { Survey } from './Survey'
import { OnboardingUpsell } from './Upsell'
import { OnboardingProvider } from './context'

export const OnboardingScreen = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const { user } = useAuth()
  const goalsState = useGoalsState()
  const activePage = React.useMemo(
    () => ({
      isOnboardingPage: pathname === '/onboarding',
      isInvitationPage: pathname === '/onboarding/invitation',
      isSurveyPage: pathname === '/onboarding/survey',
      isUpsellPage: pathname.startsWith('/onboarding/upsell')
    }),
    [pathname]
  )

  React.useEffect(() => {
    if (user) return

    history.push(
      `/login?returnTo=/onboarding${
        activePage.isInvitationPage ? '/invitation' : ''
      }`
    )
  }, [user, history])

  React.useEffect(() => {
    if (!user) return

    if (user.isInstitutional && activePage.isInvitationPage) return

    if (goalsState.onboardingComplete && user.legals >= LEGALS_VERSION) {
      return history.push('/')
    } else if (goalsState.userOnboardingRequired) {
      if (user.isInstitutional && user.isMinor)
        return history.push('/onboarding/invitation')

      if (
        !activePage.isSurveyPage &&
        !activePage.isUpsellPage &&
        (!user.isInstitutional || (user.isInstitutional && !user.isMinor))
      ) {
        return history.push('/onboarding/survey')
      }
    } else if (
      !goalsState.userOnboardingSkipped &&
      user?.legals < LEGALS_VERSION
    ) {
      if (!activePage.isUpsellPage) {
        return history.push('/onboarding/upsell')
      }
    } else {
      return history.push('/')
    }
  }, [user, history, goalsState])

  return (
    <OnboardingProvider>
      <OnboardingLayout skipGreeting={activePage.isInvitationPage}>
        {activePage.isOnboardingPage && (
          <Block align='center' justify='center' spreadX spreadY>
            <Spinner radius={65} />
          </Block>
        )}
        {activePage.isInvitationPage && <OnboardingInvitation />}
        {activePage.isSurveyPage && <Survey />}
        {activePage.isUpsellPage && <OnboardingUpsell />}
      </OnboardingLayout>
    </OnboardingProvider>
  )
}
